import useAddHomeButtonsButton, {
  key as addHomeButtonsButtonKey,
} from "@/components/CMSComponents/providedData/addHomeButtonsButton.ts";
import useCardControls, {
  key as cardControlsKey,
} from "@/components/CMSComponents/providedData/cardControls.ts";
import useFilterControls, {
  key as filterControlsKey,
} from "@/components/CMSComponents/providedData/filterControls.ts";
import useHomeButtonControls, {
  key as homeButtonControlsKey,
} from "@/components/CMSComponents/providedData/homeButtonControls.ts";
import useRecordItemControls, {
  key as recordItemControlsKey,
} from "@/components/CMSComponents/providedData/recordItemControls.ts";
import useRecordCollectionControls, {
  key as recordCollectionControlsKey,
} from "@/components/CMSComponents/providedData/recordCollectionControls.ts";
import useAddRecordItemButton, {
  key as addRecordItemButtonKey,
} from "@/components/CMSComponents/providedData/addRecordItemButton.ts";
import useEditFlipbookTocButton, {
  key as editFlipbookTocButtonKey,
} from "@/components/CMSComponents/providedData/editFlipbookTocButton.ts";
import useAppIdle, {
  key as appIdleKey,
} from "@/components/Global/providedData/appIdle.ts";
import useAutoOpenSearch, {
  key as autoOpenSearchKey,
} from "@/components/Global/providedData/autoOpenSearch.ts";
import useForms, {
  key as formsKey,
} from "@/components/CMSComponents/providedData/forms.ts";
import { provide } from "vue";

export default function useProvideInject() {
  function provideAll() {
    provide(addHomeButtonsButtonKey, useAddHomeButtonsButton());
    provide(cardControlsKey, useCardControls());
    provide(filterControlsKey, useFilterControls());
    provide(homeButtonControlsKey, useHomeButtonControls());
    provide(recordItemControlsKey, useRecordItemControls());
    provide(recordCollectionControlsKey, useRecordCollectionControls());
    provide(addRecordItemButtonKey, useAddRecordItemButton());
    provide(editFlipbookTocButtonKey, useEditFlipbookTocButton());
    provide(appIdleKey, useAppIdle());
    provide(autoOpenSearchKey, useAutoOpenSearch());
    provide(formsKey, useForms());
  }
  return { provideAll };
}
